var _g, _mask, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeasurementResult = function SvgMeasurementResult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.46154 11C1.9975 11 0 12.5359 0 14.4306V23.9051C0 25.4515 0.89134 26.8594 2.28913 27.5208L13.3309 32.7456C14.0478 33.0848 14.9522 33.0848 15.6691 32.7456L26.7109 27.5208C28.1087 26.8594 29 25.4515 29 23.9051V14.4306C29 12.5359 27.0025 11 24.5385 11H4.46154Z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_14879_79043",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H25C27.2091 0 29 1.79086 29 4V15H0V4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M0 4C0 1.79086 1.79086 0 4 0H25C27.2091 0 29 1.79086 29 4V15H0V4Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-1 4C-1 1.23858 1.23858 -1 4 -1H25C27.7614 -1 30 1.23858 30 4H28C28 2.34315 26.6569 1 25 1H4C2.34315 1 1 2.34315 1 4H-1ZM29 15H0H29ZM-1 15V4C-1 1.23858 1.23858 -1 4 -1V1C2.34315 1 1 2.34315 1 4V15H-1ZM25 -1C27.7614 -1 30 1.23858 30 4V15H28V4C28 2.34315 26.6569 1 25 1V-1Z",
    mask: "url(#path-3-inside-1_14879_79043)"
  }))));
};
export default SvgMeasurementResult;